import { Center, Spinner, Text } from '@chakra-ui/react';
import useQueryParam from 'hooks/shared/useQueryParam';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useFetchPeSelfOrdersQuery } from 'rtkQuery/sharespro/queries/peService';

import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import AppCard from 'presentation/components/shared/card/AppCard';
import PeSelfOrdersGrid from 'presentation/components/modules/pe/selfOrders/PeSelfOrdersGrid';
import SidebarRequestCard from 'presentation/components/modules/pe/shared/SidebarRequestCard';

const PeSelfOrdersPage: FC = () => {
  const { t } = useTranslation();

  const [page, setPage] = useQueryParam<number>('page', {
    ifAbsent: 1,
    provider: (val) => parseInt(val),
  });

  const { isFetching, data, error, refetch } = useFetchPeSelfOrdersQuery({
    page,
  });

  let content;
  let wrapByCard = true;
  if (data) {
    if (data.items.length > 0) {
      content = (
        <PeSelfOrdersGrid
          items={data.items}
          pageCount={data.pageCount}
          currentPage={data.currentPage}
          setPage={setPage}
          isFetching={isFetching}
        />
      );
      wrapByCard = false;
    } else {
      content = <Text>{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <ActivesPageLayout sidebarContent={<SidebarRequestCard />}>
      <Helmet>
        <title>{t('myOrdersLabel')}</title>
      </Helmet>
      <GridHeading>{t('myOrdersLabel')}</GridHeading>
      {content}
    </ActivesPageLayout>
  );
};

export default PeSelfOrdersPage;
